import { Component, ChangeDetectorRef } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { AdministrativeFeeCatalogService } from '../../../../services/administrativefeecatalog.service';
import { ServiceDto } from '../../../../models/servicedto';
import { ServicesService } from '../../../../services/services.service';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AdministrativeFeeCatalogDto } from '../../../../models/administrativefeecatalogdto';
import { Subscription, filter } from 'rxjs';
import { TranslateService, TranslatePipe, TranslateDirective, LangChangeEvent } from "@ngx-translate/core";
import { AdministrativeFeeCatalogRequest } from '../../../../models/administrativeFeeCatalogRequest';
import { AdministrativeFeeCatalogResponse } from '../../../../models/administrativeFeeCatalogResponse';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { SharedService } from '../../../../services/shared.service';
import { AlertComponentComponent } from '../../../../components/alert/alert-component.component';
@Component({
  selector: 'app-administrativeservices',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, FormsModule, CommonModule, ReactiveFormsModule, TranslatePipe, TranslateDirective, PaginatorComponent, AlertComponentComponent],
  templateUrl: './administrativeservices.component.html',
  styleUrl: './administrativeservices.component.css'
})
export class AdministrativeservicesComponent {
  links: any[] = [];
  subLinks: any[] = [];

  listCatalog: AdministrativeFeeCatalogDto[] = []; // Lista de catalogos de tarifas administrativas
  listServices: ServiceDto[] = []; // Lista de servicios
  currentLanguage: string = 'es'; // Idioma actual
  isCreate: boolean = false; // Bandera para indicar si se está creando un nuevo elemento
  isCreated: boolean = false; // Bandera para indicar si se está creando un nuevo elemento
  isError: boolean = false; // Bandera para indicar si se está creando un nuevo elemento
  errorMessage: string = ''

  selectedRowId: number | null = null; // ID de la fila seleccionada
  modifTranslates: boolean = false; // Bandera para indicar si se están modificando las traducciones
  adminFeeCatalog: AdministrativeFeeCatalogDto = new AdministrativeFeeCatalogDto(); // Objeto para almacenar la tarifa administrativa seleccionada

  administrativeFeeCatalogRequest: AdministrativeFeeCatalogRequest = new AdministrativeFeeCatalogRequest(); // Objeto para la solicitud de tarifas administrativas
  administrativeFeeCatalogResponse: AdministrativeFeeCatalogResponse = new AdministrativeFeeCatalogResponse(); // Objeto para la respuesta de tarifas administrativas

  private langChangeSubscription!: Subscription;
  constructor(private routelinks: RoutelinksService, private catalogService: AdministrativeFeeCatalogService, private translateService: TranslateService,
    private cdr: ChangeDetectorRef, private servicesService: ServicesService, private sharedService: SharedService) {
    this.currentLanguage = this.translateService.currentLang || 'es'; // Establece el idioma actual
  }
  
  administrativeCatalogForm = new FormGroup({
    code: new FormControl(''),
    descriptionCat: new FormControl('', Validators.required),
    descriptionCast: new FormControl('', Validators.required),
    descriptionIng: new FormControl('', Validators.required),
    typology: new FormControl('', Validators.required),
    activity: new FormControl(),
    registrationCancellationFee: new FormControl(false),
    registrationModificationFee: new FormControl(false),
    splitPaymentRate: new FormControl(false),
    active: new FormControl(false)
  });

  ngOnInit(): void {
    this.links = this.routelinks.linksTaxes; // Inicializa la propiedad en ngOnInit
    this.subLinks = this.routelinks.subLinksTaxes; // Inicializa la propiedad en el constructor

    this.getListAdministrativeFeeCatalog(true); // Llama al método para obtener la lista de tarifas administrativas
    this.getListServices(); // Llama al método para obtener la lista de servicios

    // Servicio encargado de escuchar cuando se cambia de página
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.administrativeFeeCatalogResponse.pageDto.currentPage = page;
      this.getListAdministrativeFeeCatalog(false);
    });

    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang; // Actualizar el idioma actual
      this.getListAdministrativeFeeCatalog(false);
      this.getListServices()
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  newModel(): void {
    this.administrativeCatalogForm.reset(); // Limpia los datos del formulario
    this.administrativeCatalogForm.enable(); // Limpia los datos del formulario

    this.selectedRowId = null; // Deselecciona la fila
    this.isCreate = true; // Cambia a modo de creación
    this.cdr.detectChanges();
    window.scrollTo(0, 600);
  }

  toggleRow(row: any): void {
    if (this.selectedRowId === row.idAdministrativeFeesCatalog) {
      window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
      setTimeout(() => {
        this.selectedRowId = null; // Deselecciona si ya estaba seleccionada

      }, 350);
      this.administrativeCatalogForm.reset();

    } else {
      this.selectedRowId = row.idAdministrativeFeesCatalog; // Selecciona la nueva fila
      this.isCreate = false; // Cambia a modo de modificación

      this.catalogService.getCatalogById(row.idAdministrativeFeesCatalog).subscribe({
        next: (administrativeFeeCatalog) => {

          this.adminFeeCatalog = administrativeFeeCatalog; // Asigna el objeto recibido a la propiedad adminFeeCatalog
          const catalanIndex = this.adminFeeCatalog?.administrativeFeeCatalogTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === "ca"
          ) ?? -1;

          const spanishIndex = this.adminFeeCatalog?.administrativeFeeCatalogTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === "es"
          ) ?? -1;

          const englishIndex = this.adminFeeCatalog?.administrativeFeeCatalogTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === "en"
          ) ?? -1;

          this.administrativeCatalogForm.patchValue({
            //code: this.adminFeeCatalog?.code,
            typology: this.adminFeeCatalog?.typology,
            descriptionCat: catalanIndex >= 0 ? this.adminFeeCatalog?.administrativeFeeCatalogTraductionDto?.[catalanIndex]?.description || '' : '',
            descriptionCast: spanishIndex >= 0 ? this.adminFeeCatalog?.administrativeFeeCatalogTraductionDto?.[spanishIndex]?.description || '' : '',
            descriptionIng: englishIndex >= 0 ? this.adminFeeCatalog?.administrativeFeeCatalogTraductionDto?.[englishIndex]?.description || '' : '',
            activity: this.adminFeeCatalog?.serviceDto?.idService || '',
            code: this.adminFeeCatalog?.codeAdministrativeFeeCatalog || '',
            active: this.adminFeeCatalog?.active || false,
            registrationCancellationFee: this.adminFeeCatalog?.registrationCancellationFee || false,
            registrationModificationFee: this.adminFeeCatalog?.registrationModificationFee || false,
            splitPaymentRate: this.adminFeeCatalog?.splitPaymentRate || false
          });
          this.administrativeCatalogForm.get('code')?.disable()
        }, error: error => {
          console.error('Error al obtener el catálogo administrativo:', error);
        }
      });
      this.cdr.detectChanges();
      window.scrollTo(0, 600);
      //Rellenar formComponent con el obj de la fila seleccionada

    }
    console.log('ID de la fila seleccionada:', this.selectedRowId);
  }

  toggleCheckbox(selectedCheckbox: string): void {
    // Establece todos los checkboxes en false excepto el seleccionado
  /*  this.administrativeCatalogForm.patchValue({
      registrationCancellationFee: selectedCheckbox === 'registrationCancellationFee',
      registrationModificationFee: selectedCheckbox === 'registrationModificationFee',
      splitPaymentRate: selectedCheckbox === 'splitPaymentRate',
    });*/
  }

  getListServices(): void {
    this.servicesService.getAllServices().subscribe({
      next: (services: any) => {
        // Aquí puedes asignar la lista de servicios a una propiedad si es necesario
        this.listServices = services.listServiceDto; // Asigna la respuesta a la propiedad listServices
        this.listServices = services.listServiceDto.map((rt: any) => {
          return {
            ...rt,
            serviceTraductionDto: rt.serviceTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
          };
        });
        console.log(this.listServices)
      },
      error: error => {
        console.log('Se ha producido un error al obtener la lista de servicios', error);
      }
    });
  }

  getListAdministrativeFeeCatalog(init: boolean) {
    if (!init) {
      this.administrativeFeeCatalogRequest.pageRequest.page = this.administrativeFeeCatalogResponse.pageDto.currentPage;
    }

    this.catalogService.getAllCatalogs(this.administrativeFeeCatalogRequest.pageRequest).subscribe({
      next: response => {
        console.log(response);
        if (response != null) {
          console.log(response.listAdministrativeFeeCatalog);
          // Asigna la lista de modelos a la propiedad listModels para mostrarlos en la tabla
          this.administrativeFeeCatalogResponse.listAdministrativeFeeCatalogDto = response.listAdministrativeFeeCatalog.map((rt: any) => {
            return {
              ...rt,
              administrativeFeeCatalogTraductionDto: rt.administrativeFeeCatalogTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
            };
          });

          if (response.pageDto !== undefined) {
            this.administrativeFeeCatalogResponse.pageDto = response.pageDto;
          }
        }
      }, error: error => {
        console.log('Se ha producido un error', error);
        this.listCatalog = []; // Asigna una lista vacía en caso de error
      }
    });
  }

  saveAdministrativeCatalog() {
    if (this.administrativeCatalogForm.valid) {

      this.modifTranslates = false;
      this.bindFormToObj();
      if (this.isCreate) {
        this.catalogService.insertCatalog(this.adminFeeCatalog).subscribe({
          next: (administrativeFeeCatalog) => {
            this.isCreated = true
            this.isCreate = false
            this.isError = false
            this.errorMessage = "S'ha creat correctament"
            this.getListAdministrativeFeeCatalog(true); // Vuelve a cargar la lista de tarifas administrativas
            this.administrativeCatalogForm.reset(); // Limpia el formulario
            this.selectedRowId = null; // Deselecciona la fila
          }
          , error: error => {
            this.isError = true
            this.errorMessage = error.error.message
            console.error('Error al crear el catálogo administrativo:', error);
          }
        });
      } else {
        this.catalogService.updateCatalog(this.modifTranslates, this.adminFeeCatalog).subscribe({
          next: (administrativeFeeCatalog) => {
            this.isCreated = true
            this.isCreate = false
            this.isError = false
            this.errorMessage = "S'ha editat correctament"
            console.log('Catálogo administrativo actualizado:', administrativeFeeCatalog);
            this.getListAdministrativeFeeCatalog(true); // Vuelve a cargar la lista de tarifas administrativas
          }
          , error: error => {
            this.isError = true
            this.errorMessage = error.error.message
            console.error('Error al actualizar el catálogo administrativo:', error);
          }
        });

      }
    } else {
      this.isError = true
      this.errorMessage = 'obligatorios'
    }
  }

  // Método para cancelar y reiniciar el formulario
  onCancel(): void {
    this.administrativeCatalogForm.reset(); // Limpia los datos del formulario
    this.selectedRowId = null; // Deselecciona cualquier fila
    this.isCreate = false; // Cambia a modo cerrado
    this.cdr.detectChanges(); // Detecta cambios para actualizar la vista
    window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
    console.log('Formulario cerrado y restablecido');
  }

  bindFormToObj() {
    if (!this.isCreate) {
      this.adminFeeCatalog.idAdministrativeFeesCatalog = this.selectedRowId || undefined; // Asigna el ID de la tasa académica seleccionada
    } else {
      this.adminFeeCatalog = new AdministrativeFeeCatalogDto(); // Inicializa de 0 el objeto
    }

    this.adminFeeCatalog.codeAdministrativeFeeCatalog = this.administrativeCatalogForm.get('code')?.value || undefined; // Asigna el código del formulario al objeto
    this.adminFeeCatalog.registrationCancellationFee = this.administrativeCatalogForm.get('registrationCancellationFee')?.value || false; // Asigna la tasa de cancelación
    this.adminFeeCatalog.registrationModificationFee = this.administrativeCatalogForm.get('registrationModificationFee')?.value || false; // Asigna la tasa de modificación
    this.adminFeeCatalog.splitPaymentRate = this.administrativeCatalogForm.get('splitPaymentRate')?.value || false; // Asigna la tasa de pago fraccionado
    this.adminFeeCatalog.active = this.administrativeCatalogForm.get('active')?.value || false; // Asigna el estado activo
    this.adminFeeCatalog.typology = this.administrativeCatalogForm.get('typology')?.value || ''; // Asigna el estado activo

    if (this.adminFeeCatalog.serviceDto == null) {
      this.adminFeeCatalog.serviceDto = new ServiceDto(); // Inicializa el objeto serviceDto si es nulo
    }
    this.adminFeeCatalog.serviceDto.idService = this.administrativeCatalogForm.get('activity')?.value || undefined; // Asigna el ID del servicio al objeto
    if (this.adminFeeCatalog.administrativeFeeCatalogTraductionDto == null) {
      this.adminFeeCatalog.administrativeFeeCatalogTraductionDto = [
        { languageDto: { idLanguage: 1 }, description: undefined },
        { languageDto: { idLanguage: 2 }, description: undefined },
        { languageDto: { idLanguage: 3 }, description: undefined }
      ]; // Inicializa ownAcademicFeeTraductionDto si es undefined o vacío; // Inicializa el array de traducciones si es nulo
    }

    this.adminFeeCatalog.administrativeFeeCatalogTraductionDto.forEach((translation) => {
      //translation.typology = this.administrativeCatalogForm.get('typology')?.value || undefined; // Asigna el tipo de tasa

      if (translation.languageDto?.code === "es" || translation.languageDto?.idLanguage === 1) {
        if (translation.description != this.administrativeCatalogForm.get('descriptionCast')?.value) {
          this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
        }
        translation.description = this.administrativeCatalogForm.get('descriptionCast')?.value ?? undefined;
      } else if (translation.languageDto?.code === "ca" || translation.languageDto?.idLanguage === 2) {
        if (translation.description != this.administrativeCatalogForm.get('descriptionCat')?.value) {
          this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
        }
        translation.description = this.administrativeCatalogForm.get('descriptionCat')?.value ?? undefined;
      } else if (translation.languageDto?.code === "en" || translation.languageDto?.idLanguage === 3) {
        if (translation.description != this.administrativeCatalogForm.get('descriptionIng')?.value) {
          this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
        }
        translation.description = this.administrativeCatalogForm.get('descriptionIng')?.value ?? undefined;
      }
    });
  }

  listCatalogSize(): number {
    return this.listCatalog.length; // Devuelve el tamaño de la lista de tarifas administrativas
  }
}
